import axiosCommon from "../axios";
export function contactUsService(obj) {
  return axiosCommon.post(`/website/contact-us/`, obj);
}
export function dlgClosureData() {
  return axiosCommon.get(`/website/portfolio`, {
    headers: {
      "X-API-KEY": "3c92f7ab-61e4-45d8-a930-8f5b1p7c1e64",
    },
  });
}
export default { contactUsService, dlgClosureData };
